import React, { FormEvent, useState } from "react";
import { ArrowUpRightIcon, MessageCircleIcon, XIcon } from "lucide-react";
import { ASK_MAPLE_ACTIONS, CONTACT } from "../data/mccContent";
type AskMapleProps = {
  onClose: () => void;
  initialQuestion?: string;
};
export function AskMaple({
  onClose,
  initialQuestion = ""
}: AskMapleProps) {
  const [question, setQuestion] = useState(initialQuestion);
  const [response, setResponse] = useState("");
  function getWhatsAppLink(message: string) {
    return `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
  }
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const cleanQuestion = question.trim();
    if (!cleanQuestion) return;
    setResponse("Thank you. For an accurate, MCC-approved answer, our Admissions team can help directly.");
  }
  function handleQuickAction(action: string) {
    setQuestion(`I would like to know more about ${action.toLowerCase()}.`);
    setResponse("For current, approved information, please connect with MCC Admissions.");
  }
  return <aside aria-label="Ask Maple admissions assistant" className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-md border border-[#dedbd3] bg-[#fbfaf6] p-5 shadow-[0_22px_70px_rgba(5,26,48,0.2)] sm:inset-x-auto sm:right-6 sm:bottom-6 sm:w-[420px]" data-id="element-124" data-mp="qn2vezaue772">
      <div className="flex items-start justify-between gap-4 border-b border-[#dedbd3] pb-5" data-id="element-125" data-mp="2y9xwyeknrac">
        <div data-id="element-126" data-mp="7xe4dha43awz">
          <p className="text-xs font-semibold tracking-[0.2em] text-[#bb1e35]" data-id="element-127" data-mp="7x4myi34uc2w">ASK MAPLE</p>
          <h2 className="mt-2 text-2xl font-medium tracking-[-0.04em] text-[#061f38]" data-id="element-128" data-mp="byzmbh1i6fe1">A considered first conversation.</h2>
        </div>
        <button type="button" onClick={onClose} className="grid h-10 w-10 shrink-0 place-items-center border border-[#cfcac0] text-[#061f38] transition-colors duration-200 hover:border-[#061f38] focus:outline-none focus:ring-2 focus:ring-[#bb1e35]" aria-label="Close Ask Maple" data-id="element-129" data-mp="gqq1q1fartcb">
          <XIcon size={18} data-id="element-130" data-mp="rigjbv2ct45m" />
        </button>
      </div>

      <p className="py-4 text-sm leading-6 text-[#4f5963]" data-id="element-131" data-mp="mlzs2rzuy9ob">
        Ask a question or choose a subject. Ask Maple only shares verified school information; the Admissions team can clarify the rest.
      </p>

      <div className="flex flex-wrap gap-2" aria-label="Suggested topics" data-id="element-132" data-mp="wc2jinrbzfkj">
        {ASK_MAPLE_ACTIONS.map(action => <button key={action} type="button" onClick={() => handleQuickAction(action)} className="border border-[#dedbd3] px-3 py-2 text-xs font-medium text-[#061f38] transition-colors duration-200 hover:border-[#bb1e35] hover:text-[#bb1e35] focus:outline-none focus:ring-2 focus:ring-[#bb1e35]" data-id="element-133" data-mp="8lyqfabrqy7s">
            {action}
          </button>)}
      </div>

      <form onSubmit={handleSubmit} className="mt-5" data-id="element-134" data-mp="1t3d6dbyjz48h">
        <label htmlFor="maple-question" className="sr-only" data-id="element-135" data-mp="1oynb9pbpxtom">Your question</label>
        <textarea id="maple-question" value={question} onChange={event => setQuestion(event.target.value)} placeholder="What would you like to know?" className="h-24 w-full resize-none border border-[#cfcac0] bg-white p-3 text-sm text-[#061f38] outline-none placeholder:text-[#7d858b] focus:border-[#061f38] focus:ring-1 focus:ring-[#061f38]" data-id="element-136" data-mp="1wiofgr5zzm2w" />
        <div className="mt-3 flex items-center justify-between gap-3" data-id="element-137" data-mp="2f9fm3kyloydl">
          <a href={getWhatsAppLink("Hello MCC, I would like to speak with Admissions.")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-xs font-semibold text-[#061f38] underline underline-offset-4 hover:text-[#bb1e35]" data-id="element-138" data-mp="2k8sj2yj6rltw">
            <MessageCircleIcon size={15} data-id="element-139" data-mp="2y8tjkcvjgr8u" /> Human handoff
          </a>
          <button type="submit" className="inline-flex items-center gap-2 bg-[#c5233d] px-4 py-3 text-xs font-semibold text-white transition-colors duration-200 hover:bg-[#a71931] focus:outline-none focus:ring-2 focus:ring-[#bb1e35] focus:ring-offset-2" data-id="element-140" data-mp="2y6gw5k70hooe">
            Ask Maple <ArrowUpRightIcon size={15} data-id="element-141" data-mp="1ab2jdzh0cx2c" />
          </button>
        </div>
      </form>

      {response && <p role="status" className="mt-4 border-l-2 border-[#bb1e35] pl-3 text-sm leading-6 text-[#394750]" data-id="element-142" data-mp="15dk8i3jfk7rp">{response}</p>}
    </aside>;
}